export default __webpack_public_path__ + "static/media/seven.6f838947.png";